import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'mtm-asset-model',
  templateUrl: './asset-model.component.html',
  styleUrl: './asset-model.component.scss',
  standalone: false,
})
export class AssetModelComponent implements OnInit {
  @Input() title: string = '';
  @Input() description: any = '';
  constructor(private readonly activeModal: NgbActiveModal) {}

  ngOnInit() {
    // Force close any remaining open dropdowns
    setTimeout(() => {
      const contextMenus = document.querySelectorAll('.dropdown-menu.show');
      contextMenus.forEach((menu) => {
        menu.classList.remove('show');
      });
    }, 0);
  }

  onConfirmSave() {
    this.activeModal.close(true);
  }

  onCancel() {
    this.activeModal.close(false);
  }
}
